// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"34d1c332","157":"4491a7f8","400":"f8dea083","486":"4b5ccd27","488":"af104311","527":"64dfd36b","786":"76ea7033","891":"9b22eadf","911":"66b6adf2"}[chunkId] + ".chunk.js";
};